import styled from 'styled-components';

export const Box = styled.div`
  .tooltip-content {
    text-decoration: dotted;
  }
`;
